
import { resendOutboundTransmissionRequest, getOutboundTransmissionByIdRequest } from  '../requests';

async function inspectOutboundTransmission({ commit }, transmissionId) {
	let transmissionDetails = await getOutboundTransmissionByIdRequest(transmissionId);
	commit('setTransmissionDetails', transmissionDetails);
}

async function resendOutboundTransmission({ commit }, transmissionId) {
	let transmissionDetails = await resendOutboundTransmissionRequest(transmissionId);
	commit('setTransmissionDetails', transmissionDetails);
}
export default { inspectOutboundTransmission, resendOutboundTransmission };